<template>



  <b-modal no-close-on-backdrop ref="my-modal" size="xl" hide-footer title="Exámenes" v-on:hide="onModalHide">

    <div class="lessons-model">
      <input type="text" class="form-control bg-light border-0 small" placeholder="Buscar por título"
             aria-label="Search" aria-describedby="basic-addon2" v-model="searchExams"  v-on:keyup="loadExams">
    </div>

    <div class="lessons-model">
      <table class="table">
        <thead>
        <tr>
          <th>Titulo</th>

        </tr>
        </thead>
        <tbody v-for="(exam, index) in exams" :key="index">
        <tr>
          <td>{{ exam.title }}</td>

          <td><div class="col col-sm-6 col-md-6 col-lg-6 text-center">
            <b-button class="mt-3" v-on:click="saveExam(exam.id, )"
                      block>Agregar</b-button>
          </div></td>
        </tr>
        </tbody>

      </table>
    </div>

  </b-modal>

</template>


<script>
import Multiselect from 'vue-multiselect'
import axios from "axios";


export default {
  props: {
    type: String,
  },
  components: {
    Multiselect
  },
  data() {
    return {
      lessonsItems: [],
      searchLessons: "",
      searchExams: "",
      exams: [],
      isLoading: false,
    }
  },
  methods: {
    limitText (count) {
      return `and ${count} other countries`
    },
    saveExam(examId) {
      this.$emit('saveExam', {id: examId, typeExam: this.type} );
    },
    loadExams() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/exams/getExamsListforAdd/" , {
          params: {
            search: this.searchExams,
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          if (response.data) {
            response.data;
          }
          this.exams = response.data;

        })
        .catch((err) => {
          console.log(err.message);;
        });
    },
     onModalHide() {
       this.exams= '';
    },
    showModal() {
      this.$refs['my-modal'].show();
    },
  }
}
</script>



<style scoped>

</style>
